import { gql } from "../__generated__";

export const GetPersonById = gql(`
  query GetPersonById(
    $where: PersonWhereUniqueInput!
    $hydrateRelationships: Boolean!
  ) {
    person: person(where: $where) {
      id
      familyName
      givenName
      sex
      description {
        document(hydrateRelationships: $hydrateRelationships)
      }
      images {
        imageObjects {
          title
          images {
            bild {
              url
              id
            }
          }
        }
        images {
          bild {
            url
            id
          }
          objekte {
            title
            id
            description {
              document(
                hydrateRelationships: $hydrateRelationships
              )
            }
            copyright {
              name
            }
            images {
              title
              name
            }
            periodOfOrigin {
              displayName
            }
            authorPerson {
              familyName
              givenName
              id
            }
            authorGroup {
              id
              bezeichnung
            }
            personsOnWork {
              familyName
              givenName
              id
            }
            groupsOnWork {
              id
              bezeichnung
            }
            locationOnWork {
              id
              name
            }
          }
        }
      }
      occupation {
        name
        weiblich
      }
      nickname {
        document(hydrateRelationships: $hydrateRelationships)
      }
      dateOfDeath
      dateOfBirth
      periodOfDeath {
        zeitspanne {
          von
          bis
        }
      }
      mother {
        id
        familyName
        givenName
        dateOfDeath
        dateOfBirth
        sex
        periodOfDeath {
          zeitspanne {
            von
            bis
          }
        }
      }
      father {
        id
        familyName
        givenName
        dateOfDeath
        dateOfBirth
        sex
        periodOfDeath {
          zeitspanne {
            von
            bis
          }
        }
      }
      fatherOf {
        id
        familyName
        givenName
      }
      motherOf {
        id
        familyName
        givenName
      }
      weddings {
        spouses {
          id
          familyName
          givenName
        }
      }
      objectAuthor {
        id
        title
      }
      weblinks {
        document
      }
      eventCharacters {
        id
        title
      }
      onEvent {
        id
        title
      }
      groupCharacters {
        id
        bezeichnung
      }
    }
  }
`);

export const GetPeople = gql(`
  query GetPeople($take: Int, $skip: Int, $orderBy: [PersonOrderByInput!], $where: PersonWhereInput, $hydrateRelationships: Boolean!) {
    count: peopleCount(where: $where)
    items: people(take: $take, skip: $skip, orderBy: $orderBy, where: $where) {
      id
      familyName
      givenName
      displayName
      dateOfBirth
      dateOfDeath
      sex
      placeOfBirth {
        displayName
      }
      images {
        imageObjects {
          title
          images {
            bild {
              url
              id
            }
          }
        }
        images {
          bild {
            url
            id
          }
          objekte {
            title
            id
            description {
              document(
                hydrateRelationships: $hydrateRelationships
              )
            }
            copyright {
              name
            }
            images {
              title
              name
            }
            periodOfOrigin {
              displayName
              zeitspanne {
                von
                bis
              }
            }
            authorPerson {
              familyName
              givenName
              id
            }
            authorGroup {
              id
              bezeichnung
            }
            personsOnWork {
              familyName
              givenName
              id
            }
            groupsOnWork {
              id
              bezeichnung
            }
            locationOnWork {
              id
              name
            }
          }
        }
      }
      nickname {
        document(hydrateRelationships: $hydrateRelationships)
      }
      description {
        document(hydrateRelationships: $hydrateRelationships)
      }
    }
  }
`);
